import { getState, useState } from '@/framework';
import { type IExportState, type StateType } from '@/version-types';
import { createStore } from './store';
import { type Store } from './types';

const name = 'text-edit-state';

type ModuleType = StateType<Store, typeof name>;

export const useTextEditState = () => {
    return useState<ModuleType>()[name];
};

export const getTextEditState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

const exportState: IExportState = {
    name,
    createState: createStore,
};

export default exportState;
